import { ComponentTypes } from './ComponentTypes';

interface ITrackingEvent {
    [key: string]: string;
}
export const trackingShadeGroupEventName: ITrackingEvent = {
    [ComponentTypes.PRODUCT_FULL]: 'spp filter',
    [ComponentTypes.PRODUCT_BRIEF]: 'product grid filter',
    [ComponentTypes.PRODUCT_QUICKSHOP]: 'quickshop filter'
};

export const trackingShadeGroupEventAction: ITrackingEvent = {
    [ComponentTypes.PRODUCT_FULL]: 'filter - spp shade filter',
    [ComponentTypes.PRODUCT_BRIEF]: 'filter - product grid shade filter',
    [ComponentTypes.PRODUCT_QUICKSHOP]: 'filter - quickshop shade filter'
};
